<template>
  <div>
    <v-textarea
      :class="classes"
      :placeholder="placeholder"
      :name="name"
      v-model="inputVal"
      :counter="counter"
      :maxlength="maxlength"
      :auto-grow="autoGrow"
      :rows="rows"
      v-validate="validation"
      :error-messages="errorMessages && errors.first(name) ? errorMessages : errors.first(name)"
      @focus="focusField()"
      @blur="showApendIcon = false"
      :append-icon="showApendIcon && $vuetify.breakpoint.xsOnly ? icon : ''"
      @click:append="blurField()"
      ref="input"
    />
  </div>
</template>

<script>
import { VTextarea } from 'vuetify/lib';
export default {
  props: ['placeholder', 'name', 'value', 'maxlength', 'counter', 'classes', 'icon', 'autoGrow', 'rows', 'validation', 'errorMessages'],
  components: { VTextarea },
  watch: {
    inputVal(newValue){
      this.$emit('input', newValue.trim());
    }
  },
  data() {
    return {
      inputVal: this.value,
      showApendIcon: false
    };
  },
  methods: {
    blurField() {
      this.$refs.input.blur();
      this.showApendIcon = false;
    },
    focusField(){
      this.showApendIcon = true;
    }
  },
  created(){
    //first setting the value of input
    this.inputVal = this.value;
  }
};
</script>

<style scoped></style>